import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/billing',
    name: 'billing',
    redirect: '/accounts?tab=billing',
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_BILLING_READ_PERMISSION'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/billing/create',
    name: 'billingCreate',
    component: () => import('@/views/restricted/accounts/billing/BillingCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_BILLING_CREATE_PERMISSION'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/billing/:billingId/edit',
    name: 'billingUpdate',
    component: () => import('@/views/restricted/accounts/billing/BillingUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_BILLING_UPDATE_PERMISSION'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/billing/:billingId',
    name: 'billingDetail',
    component: () => import('@/views/restricted/accounts/billing/BillingDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_BILLING_READ_PERMISSION'],
      menuSelected: 'accounts'
    }
  }
]
